<div class="icon-container"
     #iconContainer
     tabindex="0"
     [pTooltip]="isPopoverOpen() ? undefined : 'Favoriten'"
     tooltipPosition="bottom"
     tooltipEvent="both"
     (keydown.enter)="onClick($event)">
	<a #popoverTarget
	   (click)="onClick($event)"
	   tabindex="-1">
		<mat-icon svgIcon="allianz_favoriten"
		          class="default-icon"></mat-icon>
		<mat-icon svgIcon="allianz_favoriten_hover"
		          class="hover_icon"></mat-icon>
	</a>
</div>
<p-popover #popover (onShow)="onPopoverShow()" (onHide)="isPopoverOpen.set(false)" [dt]="popoverDt">
	<div #popoverContent
	     pFocusTrap
	     (keydown.escape)="onPopoverEscape($event)">
		@if (!favoriten()?.length) {
			<div class="tooltip-link-Container">{{'text.no.favourites' | msgKeyCached}}</div>
		} @else {
			@for (navItem of favoriten(); track navItem.url) {
				<div class="tooltip-link-Container">
					<a tabindex="0"
					   [routerLink]="navItem.url">{{navItem.name}}</a>
				</div>
			}
		}
	</div>
</p-popover>